import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../components/Header";
import SimpleTable from "../components/SimpleTable";
import Badge from "../components/Badge";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  const authUserString = sessionStorage.getItem("authUserData");
  const authUser = JSON.parse(authUserString);
  const loginUserID = authUser?.id;
  const CompanyID = authUser?.company_id;

  // Pagination (if needed later)
  const [page, setPage] = useState(1);
  const perPage = 10;

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `https://goelectronix.in/api/v1/keys/report?sender_id=${loginUserID}&mode=1&company_id=${CompanyID}&page=${page}&per_page=${perPage}`
        );

        const data = res.data.data || [];
        setOrders(data);
      } catch (err) {
        console.error("Error fetching orders:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [page]);

  // Map API data to table rows
  const rows = orders.map((order, index) => [
    index + 1, // Sr No.
    new Date(order.created_at).toLocaleDateString(), // Date
    `${order.receiver_name} (${order.receiver_code})`, // Retailer (Code)
    order.key_type === 1 ? "Regular" : "Smart", // Type
    order.package_name, // Package
    order.qty, // Count
    `₹ ${order.key_rate}`,
    `₹ ${order.amount}`, // Amount
    <Badge
      key={order.id}
      label={order.mode === 1 ? "Completed" : "Pending"} // Example logic
      color={order.mode === 1 ? "blue" : "red"}
    />,
  ]);

  return (
    <div className="space-y-3 sm:space-y-4">
      <Header title="Orders" />
      {loading ? (
        <p className="text-center text-gray-500">Loading orders...</p>
      ) : (
        <SimpleTable
          headers={[
            "Sr No.",
            "Date",
            "Retailer (Code)",
            "Type",
            "Package",
            "Count",
            "Key Rate",
            "Amount",
            "Status",
          ]}
          rows={rows}
        />
      )}

      {/* Optional: Pagination controls */}
      <div className="flex justify-center gap-2 mt-4">
        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
          className="px-3 py-1 rounded border"
        >
          Prev
        </button>
        <span>{page}</span>
        <button
          disabled={orders.length < perPage}
          onClick={() => setPage(page + 1)}
          className="px-3 py-1 rounded border"
        >
          Next
        </button>
      </div>
    </div>
  );
}


// import Header from "../components/Header";
// import SimpleTable from "../components/SimpleTable";
// import Badge from "../components/Badge";

// export default function Orders() {
//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header title="Orders" />
//       <SimpleTable
//         headers={[ "Sr No.","Date","Retailer (Code)","Type","Package","Count","Amount", "Status"]}
//         rows={[["ORD-10013", "Maha Mobile Hub (RT-1001)", "₹ 52,400", "2025-09-22", Badge("Completed")], ["ORD-10014", "Sai Krupa (RT-1003)", "₹ 18,900", "2025-09-22", Badge("Pending", "red")]]}
//       />
//     </div>
//   );
// }